import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import SegmentBuilder from "./SegmentBuilder";
import TemplateLibrary from "./TemplateLibrary";
import CampaignList from "./CampaignList";
import { tokens } from "./utils";

const TABS = [
  { key: "segments", label: "Segments" },
  { key: "templates", label: "Templates" },
  { key: "campaigns", label: "Campaigns" },
];

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 60px",
    marginLeft: "220px",
    boxSizing: "border-box",
  },
  pageTitle: {
    color: theme.colors.DodgerBlue,
    fontFamily: theme.fontFamily.MARKPROBOLD,
    fontSize: 24,
    marginBottom: 8,
  },
  pageSubtitle: {
    fontSize: 13,
    color: tokens.textMuted,
    fontFamily: theme.fontFamily.MARKPRO,
    marginBottom: 28,
  },
  tabs: {
    display: "flex",
    gap: 4,
    borderBottom: `2px solid ${tokens.border}`,
    marginBottom: 32,
  },
  tab: {
    padding: "10px 20px",
    fontSize: 14,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    cursor: "pointer",
    color: tokens.textMuted,
    borderBottom: "2px solid transparent",
    marginBottom: -2,
    transition: "color 0.15s, background 0.15s, border-color 0.15s",
    borderRadius: "4px 4px 0 0",
    "&:hover": { color: theme.colors.DodgerBlue, background: tokens.tint },
  },
  tabActive: {
    color: theme.colors.DodgerBlue,
    fontFamily: theme.fontFamily.MARKPROBOLD,
    borderBottomColor: theme.colors.DodgerBlue,
    background: tokens.tint,
  },
}));

export default function EngagementPage() {
  const classes = useStyles();
  const [tab, setTab] = useState("segments");

  return (
    <div className={classes.root}>
      <div className={classes.pageTitle}>Engagement</div>
      <div className={classes.pageSubtitle}>
        Segment your users, manage notification templates, and run targeted campaigns.
      </div>

      <div className={classes.tabs}>
        {TABS.map((t) => (
          <div
            key={t.key}
            className={`${classes.tab} ${tab === t.key ? classes.tabActive : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </div>
        ))}
      </div>

      {tab === "segments" && <SegmentBuilder />}
      {tab === "templates" && <TemplateLibrary />}
      {tab === "campaigns" && <CampaignList />}
    </div>
  );
}
